export const shouldSkipOffersQuery = true;
export const UNAUTHENTICATED_REDEMPTIONS_ENABLED = true;
